module.exports = __webpack_public_path__ + "static/media/trimex_fina_flores.14eebe83.png";